import { render, staticRenderFns } from "./upload-image.vue?vue&type=template&id=ed70524c&scoped=true&"
import script from "./upload-image.vue?vue&type=script&lang=js&"
export * from "./upload-image.vue?vue&type=script&lang=js&"
import style0 from "./upload-image.vue?vue&type=style&index=0&id=ed70524c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed70524c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/galexp/development/web/educraft-vue-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ed70524c')) {
      api.createRecord('ed70524c', component.options)
    } else {
      api.reload('ed70524c', component.options)
    }
    module.hot.accept("./upload-image.vue?vue&type=template&id=ed70524c&scoped=true&", function () {
      api.rerender('ed70524c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/upload-image.vue"
export default component.exports